var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { BaseDict } from "./dict";
import { config } from "./config";
import { YourbetMiniBetSlip } from "./YourbetMiniBetSlip";
import { YourbetMiniBetSlipData } from "./data";
import { Parser } from "../../parser";
import { Retriever } from "../../retriever";
var _localMOCKTYPE;
var YourBetDataMock;
if (process.env.NODE_ENV === "development") {
    _localMOCKTYPE = require("../../mocks");
    YourBetDataMock = _localMOCKTYPE.YourBetDataMock;
}
var YourbetMiniBetSlipRoot = /** @class */ (function (_super) {
    __extends(YourbetMiniBetSlipRoot, _super);
    // constructor sets defaults
    function YourbetMiniBetSlipRoot(domId, options) {
        if (options === void 0) { options = {
            dict: BaseDict,
            cms: {},
            navHandler: {},
            dataProvider: {},
            betSlipUtil: {},
            oddsUtil: {},
            facade: {},
            gameStatus: {},
            timeControl: {},
            panelId: "",
            storageUtils: {},
            userInfo: {}
        }; }
        var _this = _super.call(this, domId, options) || this;
        if (process.env.NODE_ENV === "development") {
            // setup dictionary for debug build
            _this.options.dict = BaseDict;
            // setup data mocks for debug build
            _this.dataProvider = new YourbetMiniBetSlipData(new Parser(new Retriever(window["sbMsgBus"])), _this.options.dict);
            //export data store to window for debug purposes
            window["YourbetMiniBetSlipDATA"] = _this.dataProvider;
            window["YourbetMock"] = new YourBetDataMock(window["sbMsgBus"]);
            window["YourbetMock"].activate();
        }
        // if no provided dictionary is not full fill in the missing keys with the base one
        _this.options.dict = __assign({}, BaseDict, (options.dict || {}));
        // merge default and CMS options
        _this.options.cms = __assign({}, config, (options.cms || {}));
        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {
            _this.dataProvider = new YourbetMiniBetSlipData(new Parser(new Retriever(options.dataProvider)), _this.options.dict);
        }
        return _this;
    }
    YourbetMiniBetSlipRoot.prototype.beforeActivate = function () {
        this.dataProvider.activate();
        return _super.prototype.beforeActivate.call(this);
    };
    YourbetMiniBetSlipRoot.prototype.activate = function () {
        return _super.prototype.activate.call(this, React.createElement(YourbetMiniBetSlip, { dataProvider: this.dataProvider, dict: this.options.dict }));
    };
    return YourbetMiniBetSlipRoot;
}(BaseBlock));
export { YourbetMiniBetSlipRoot };
window["YourbetMiniBetSlip"] = YourbetMiniBetSlipRoot;
broadcastBlockLoad("YourbetMiniBetSlip");
//# sourceMappingURL=index.js.map